var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminWorkflowEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.49993 15.1255L15.6633 8.96214C14.6263 8.5292 13.6846 7.89665 12.8916 7.10047C12.095 6.30731 11.4622 5.36528 11.0291 4.32797L4.86577 10.4913C4.38493 10.9721 4.1441 11.213 3.93743 11.478C3.69336 11.7907 3.48407 12.1291 3.31327 12.4871C3.1691 12.7905 3.0616 13.1138 2.8466 13.7588L1.7116 17.1613C1.65936 17.3171 1.65161 17.4844 1.68922 17.6443C1.72683 17.8043 1.80831 17.9506 1.92449 18.0667C2.04068 18.1829 2.18697 18.2644 2.34692 18.302C2.50688 18.3396 2.67415 18.3319 2.82993 18.2796L6.23243 17.1446C6.87827 16.9296 7.20077 16.8221 7.5041 16.678C7.86243 16.5071 8.20077 16.298 8.51327 16.0538C8.77827 15.8471 9.0191 15.6063 9.49993 15.1255ZM17.3733 7.25214C17.9878 6.63761 18.333 5.80413 18.333 4.93505C18.333 4.06598 17.9878 3.2325 17.3733 2.61797C16.7587 2.00344 15.9253 1.6582 15.0562 1.6582C14.1871 1.6582 13.3536 2.00344 12.7391 2.61797L11.9999 3.35714L12.0316 3.44964C12.3959 4.4919 12.9919 5.43789 13.7749 6.2163C14.5766 7.02272 15.5557 7.63056 16.6341 7.9913L17.3733 7.25214Z",
    fill: "#637381"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminWorkflowEdit);
export default __webpack_public_path__ + "static/media/adminWorkflowEdit.734b4c50410795fc7396067bf5265309.svg";
export { ForwardRef as ReactComponent };